// extracted by mini-css-extract-plugin
export default {"root":"RigthWrongCount_root__sfq2O"};